/** Vite public env (replaces NEXT_PUBLIC_*) */
const DEFAULT_DEV_API_BASE_URL =
  "https://cuo-cmd-service-405179164448.us-central1.run.app/api/v1/";

function normalizeApiBaseUrl(url: string): string {
  if (!url) return "";
  return url.endsWith("/") ? url : `${url}/`;
}

function resolveApiBaseUrl(): string {
  const configured = import.meta.env.VITE_API_BASE_URL?.trim();
  if (configured) return normalizeApiBaseUrl(configured);
  if (import.meta.env.DEV) return DEFAULT_DEV_API_BASE_URL;
  return "";
}

export const env = {
  apiBaseUrl: resolveApiBaseUrl(),
  baseUrl: import.meta.env.VITE_BASE_URL ?? "",
  appBaseUrl: import.meta.env.VITE_APP_BASE_URL ?? "",
  devBaseUrl: import.meta.env.VITE_DEV_BASE_URL ?? "",
  wsBaseUrl: import.meta.env.VITE_WS_BASE_URL ?? "",
};
